import { render, staticRenderFns } from "./CSelect2.vue?vue&type=template&id=2c32d880&scoped=true&"
import script from "./CSelect2.vue?vue&type=script&lang=js&"
export * from "./CSelect2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c32d880",
  null
  
)

export default component.exports